export * from './components';



// WEBPACK FOOTER //
// ./src/frontend/modules/address-book/entity/index.js